/**
 * @hidden
 */
export var createMaxValidator = function (maxValue) {
    return function (c) {
        var err = {
            maxError: {
                maxValue: maxValue,
                value: c.value
            }
        };
        return (c.value !== null && c.value > maxValue) ? err : null;
    };
};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-inputs/dist/es/validators/max.validator.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/validators/max.validator.js
// module chunks = vendor